module.exports = __webpack_public_path__ + "img/Classroom-text.2a3a3dca.jpg";